<template>
  <v-container>
    <div class="d-flex justify-center my-10">
      <img :src="logoImg ?? undefined" width="50%" height="50%">
    </div>
    <div>
      <h2 class="mb-3 font-900 text-center">
        MAINTENANCE<span class="color-primary"></span>
      </h2>
      <h4 class="text-center">{{ maintenanceMessage }}</h4>
    </div>
  </v-container>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'maintenance',

  data: () => ({
    logoImg: require('@/assets/logo.png'),
  }),

  computed: {
    maintenanceMessage(): string {
      const message = process.env.VUE_APP_MANTENANCE_MESSAGE;
      if (message) {
        return message;
      }
      return '';
    },
  },
});
</script>
<style></style>
